 
 
import { messaging } from "@/lib/firebase";
import { onMessage } from "firebase/messaging";
import { toast } from "react-toastify";

export const setupForegroundNotifications = () => {
  onMessage(messaging, (payload) => {
    console.log("Foreground notification:", payload);

    // const title = payload?.notification?.title || "Notification";
    // const body = payload?.notification?.body || "";

    // toast.info(
    //   <div>
    //     <strong>{title}</strong>
    //     <div style={{ fontSize: "0.9rem" }}>{body}</div>
    //   </div>,
    // );
  });
};
